import Search from './Search'
export { Search }
export default Search



// WEBPACK FOOTER //
// ./src/components/Search/index.js